import { Stack, Typography } from "@mui/material";
import type { InvestorCommunication } from "../../api/types/investorCommunicationsTypes";
import NewsItemMeta from "./NewsItemMeta";
import NewsVideoPlayer from "./NewsVideoPlayer";

interface Props {
  newsItem: InvestorCommunication;
  documentViewSessionId?: string;
}

const NewsDetailsVideoContent = ({ newsItem, documentViewSessionId }: Props) => (
  <Stack spacing={2.5} sx={{ width: "100%" }}>
    {newsItem.videoContent ? (
      <NewsVideoPlayer videoContent={newsItem.videoContent} documentViewSessionId={documentViewSessionId} />
    ) : (
      <Typography color="textSecondary">This video is currently unavailable</Typography>
    )}
    <Typography variant="h2">{newsItem.title}</Typography>
    <NewsItemMeta publishedAt={newsItem.publishedAt} categories={newsItem.categories} status={newsItem.status} />
    {newsItem.description && <Typography sx={{ whiteSpace: "pre-line" }}>{newsItem.description}</Typography>}
  </Stack>
);

export default NewsDetailsVideoContent;
